var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnterpriseRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.459,
    height: 24.459,
    viewBox: "0 0 24.459 24.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.229,9.578A10.651,10.651,0,1,1,9.578,20.229,10.653,10.653,0,0,1,20.229,9.578m0-1.578A12.229,12.229,0,1,0,32.459,20.229,12.231,12.231,0,0,0,20.229,8Zm-.567,5.917H20.8a.592.592,0,0,1,.591.616l-.345,8.284a.592.592,0,0,1-.591.567h-.443a.592.592,0,0,1-.591-.567l-.345-8.284a.592.592,0,0,1,.591-.616Zm.567,10.454a1.381,1.381,0,1,0,1.381,1.381A1.381,1.381,0,0,0,20.229,24.372Z",
    transform: "translate(-8 -8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnterpriseRisk);
export default __webpack_public_path__ + "static/media/Icon-EnterpriseRisk.795ddf247f6da0509dd63cde28ddeaed.svg";
export { ForwardRef as ReactComponent };